webpackJsonp([114276838955818,60335399758886],{

/***/ 125:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"The Customs - Agencja Eventowa"}}},"layoutContext":{}}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(268);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(125);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(150);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(147);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(146);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(60);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(60);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(148);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Facebook = __webpack_require__(65);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Youtube = __webpack_require__(67);
	
	var _Youtube2 = _interopRequireDefault(_Youtube);
	
	var _Instagram = __webpack_require__(66);
	
	var _Instagram2 = _interopRequireDefault(_Instagram);
	
	__webpack_require__(127);
	
	var _kris = __webpack_require__(155);
	
	var _kris2 = _interopRequireDefault(_kris);
	
	var _karol = __webpack_require__(154);
	
	var _karol2 = _interopRequireDefault(_karol);
	
	var _aboutNoPhoto = __webpack_require__(62);
	
	var _aboutNoPhoto2 = _interopRequireDefault(_aboutNoPhoto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var people = [{
	  name: 'Kris',
	  avatar: _kris2.default,
	  email: 'k.kubis@customart.pl',
	  tel: '+48 660 717 053'
	}, {
	  name: 'Karol',
	  avatar: _karol2.default,
	  email: 'k.kepka@customart.pl',
	  tel: '+48 724 306 101'
	}];
	
	var ContactPerson = function ContactPerson(props) {
	  return _react2.default.createElement(
	    'article',
	    { className: 'contact-person' },
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-person__avatar' },
	      _react2.default.createElement('img', { src: props.avatar, className: 'contact-person__image', alt: props.name })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-person__content' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'contact-person__title' },
	        props.name
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contact-person__text' },
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:' + props.tel, className: 'contact-person__email' },
	          props.tel
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'contact-person__text' },
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + props.email, className: 'contact-person__email' },
	          props.email
	        )
	      )
	    )
	  );
	};
	
	var ContactModal = function ContactModal(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'contact-modal' },
	    _react2.default.createElement('dic', { className: 'contact-modal__overlay', onClick: props.onClose }),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact-modal__content' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'contact-modal__title' },
	        'Kontakt'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'contact-modal__people' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'contact-modal__list' },
	          people.map(function (person, index) {
	            return _react2.default.createElement(
	              'li',
	              { className: 'contact-modal__element', key: index },
	              _react2.default.createElement(ContactPerson, person)
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'contact-modal__socials' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.facebook.com/customartagencja/',
	            rel: 'noopener',
	            target: '_blank'
	          },
	          _react2.default.createElement(_Facebook2.default, null)
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.youtube.com/channel/UCetpXU-6AoO_WA1IL1A_6_Q',
	            rel: 'noopener',
	            target: '_blank'
	          },
	          _react2.default.createElement(_Youtube2.default, null)
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.instagram.com/customart_agencja/',
	            rel: 'noopener',
	            target: '_blank'
	          },
	          _react2.default.createElement(_Instagram2.default, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactModal;
	module.exports = exports['default'];

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(149);
	
	var _Modal = __webpack_require__(91);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$PureComponent) {
	  _inherits(Contact, _React$PureComponent);
	
	  function Contact() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Contact);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
	      opened: false
	    }, _this.closeOnEscape = function (e) {
	      if (e.keyCode === 27) {
	        _this.closeContact();
	      }
	    }, _this.openContact = function () {
	      _this.setState({ opened: true });
	    }, _this.closeContact = function () {
	      _this.setState({ opened: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Contact.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('keydown', this.closeOnEscape);
	  };
	
	  Contact.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('keydown', this.closeOnEscape);
	  };
	
	  Contact.prototype.render = function render() {
	    var Element = this.props.element;
	    return _react2.default.createElement(
	      'div',
	      { className: 'contact-wrapper' },
	      _react2.default.createElement(Element, { onClick: this.openContact }),
	      this.state.opened && _react2.default.createElement(
	        _reactPortal.Portal,
	        null,
	        _react2.default.createElement(_Modal2.default, { isOpened: this.state.opened, onClose: this.closeContact })
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.PureComponent);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/karol.33d5b3e4.jpg";

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kris.bbe7a465.jpg";

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Contact = __webpack_require__(92);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactButton = function ContactButton(props) {
	  return _react2.default.createElement(
	    'button',
	    { className: 'hero-links__link', onClick: props.onClick },
	    _react2.default.createElement(
	      'span',
	      null,
	      'Kontakt'
	    )
	  );
	};
	
	var HeroLinks = function HeroLinks() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'hero-links' },
	    _react2.default.createElement(
	      'div',
	      { className: 'hero-links__wrapper' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/o-nas', className: 'hero-links__link' },
	        'O nas'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/oferta', className: 'hero-links__link' },
	        'Oferta'
	      ),
	      _react2.default.createElement(_Contact2.default, { element: ContactButton, className: 'hero-links__link' })
	    )
	  );
	};
	
	exports.default = HeroLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BurgerButton = function BurgerButton(props) {
	  var classes = (0, _classnames2.default)('hamburger hamburger--elastic', {
	    'is-active': props.active
	  });
	  return _react2.default.createElement(
	    'button',
	    {
	      className: classes,
	      type: 'button',
	      'aria-label': 'Menu',
	      'aria-controls': props.controls,
	      onClick: props.onClick
	    },
	    _react2.default.createElement(
	      'span',
	      { className: 'hamburger-box' },
	      _react2.default.createElement('span', { className: 'hamburger-inner' })
	    )
	  );
	};
	
	exports.default = BurgerButton;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Facebook = function Facebook() {
		return _react2.default.createElement(
			"svg",
			{
				x: "0px", y: "0px",
				width: "24",
				height: "24",
				viewBox: "0 0 612 612"
			},
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M612,306C612,137.004,474.995,0,306,0C137.004,0,0,137.004,0,306c0,168.995,137.004,306,306,306 C474.995,612,612,474.995,612,306z M223.825,306v-58.557h35.885V212.03c0-47.764,14.271-82.175,66.569-82.175h62.201v58.418 h-43.785c-21.949,0-26.929,14.577-26.929,29.849v29.32h67.487L376.046,306h-58.278v176.617H259.71V306H223.825z" })
			)
		);
	};
	
	exports.default = Facebook;
	module.exports = exports["default"];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Instagram = function Instagram() {
		return _react2.default.createElement(
			"svg",
			{ x: "0px", y: "0px",
				width: "24px", height: "24px",
				viewBox: "0 0 50 50"
			},
			_react2.default.createElement("path", { d: "M24.825,29.796c2.739,0,4.972-2.229,4.972-4.97c0-1.082-0.354-2.081-0.94-2.897c-0.903-1.252-2.371-2.073-4.029-2.073 c-1.659,0-3.126,0.82-4.031,2.072c-0.588,0.816-0.939,1.815-0.94,2.897C19.854,27.566,22.085,29.796,24.825,29.796z" }),
			_react2.default.createElement("polygon", { points: "35.678,18.746 35.678,14.58 35.678,13.96 35.055,13.962 30.891,13.975 30.907,18.762" }),
			_react2.default.createElement("path", { d: "M24.826,0C11.137,0,0,11.137,0,24.826c0,13.688,11.137,24.826,24.826,24.826c13.688,0,24.826-11.138,24.826-24.826 C49.652,11.137,38.516,0,24.826,0z M38.945,21.929v11.56c0,3.011-2.448,5.458-5.457,5.458H16.164 c-3.01,0-5.457-2.447-5.457-5.458v-11.56v-5.764c0-3.01,2.447-5.457,5.457-5.457h17.323c3.01,0,5.458,2.447,5.458,5.457V21.929z"
			}),
			_react2.default.createElement("path", { d: "M32.549,24.826c0,4.257-3.464,7.723-7.723,7.723c-4.259,0-7.722-3.466-7.722-7.723c0-1.024,0.204-2.003,0.568-2.897 h-4.215v11.56c0,1.494,1.213,2.704,2.706,2.704h17.323c1.491,0,2.706-1.21,2.706-2.704v-11.56h-4.217 C32.342,22.823,32.549,23.802,32.549,24.826z" })
		);
	};
	
	exports.default = Instagram;
	module.exports = exports["default"];

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Facebook = __webpack_require__(65);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Youtube = __webpack_require__(67);
	
	var _Youtube2 = _interopRequireDefault(_Youtube);
	
	var _Instagram = __webpack_require__(66);
	
	var _Instagram2 = _interopRequireDefault(_Instagram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Socials = function Socials() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'menu-socials' },
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.facebook.com/customartagencja/',
	        rel: 'noopener',
	        target: '_blank',
	        className: 'menu-socials__link'
	      },
	      _react2.default.createElement(_Facebook2.default, null)
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.youtube.com/channel/UCetpXU-6AoO_WA1IL1A_6_Q',
	        rel: 'noopener',
	        target: '_blank',
	        className: 'menu-socials__link'
	      },
	      _react2.default.createElement(_Youtube2.default, null)
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: 'https://www.instagram.com/customart_agencja/',
	        rel: 'noopener',
	        target: '_blank',
	        className: 'menu-socials__link'
	      },
	      _react2.default.createElement(_Instagram2.default, null)
	    )
	  );
	};
	
	exports.default = Socials;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YoutubeIcon = function YoutubeIcon() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "24", height: "24", viewBox: "0 0 24 24" },
	    _react2.default.createElement("path", { d: "M10.918 13.933h.706v3.795h-.706v-.419c-.13.154-.266.272-.405.353-.381.218-.902.213-.902-.557v-3.172h.705v2.909c0 .153.037.256.188.256.138 0 .329-.176.415-.284v-2.881zm.642-4.181c.2 0 .311-.16.311-.377v-1.854c0-.223-.098-.38-.324-.38-.208 0-.309.161-.309.38v1.854c-.001.21.117.377.322.377zm-1.941 2.831h-2.439v.747h.823v4.398h.795v-4.398h.821v-.747zm4.721 2.253v2.105c0 .47-.176.834-.645.834-.259 0-.474-.094-.671-.34v.292h-.712v-5.145h.712v1.656c.16-.194.375-.354.628-.354.517.001.688.437.688.952zm-.727.043c0-.128-.024-.225-.075-.292-.086-.113-.244-.125-.367-.062l-.146.116v2.365l.167.134c.115.058.283.062.361-.039.04-.054.061-.141.061-.262v-1.96zm10.387-2.879c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-10.746-2.251c0 .394.12.712.519.712.224 0 .534-.117.855-.498v.44h.741v-3.986h-.741v3.025c-.09.113-.291.299-.436.299-.159 0-.197-.108-.197-.269v-3.055h-.741v3.332zm-2.779-2.294v1.954c0 .703.367 1.068 1.085 1.068.597 0 1.065-.399 1.065-1.068v-1.954c0-.624-.465-1.071-1.065-1.071-.652 0-1.085.432-1.085 1.071zm-2.761-2.455l.993 3.211v2.191h.835v-2.191l.971-3.211h-.848l-.535 2.16-.575-2.16h-.841zm10.119 10.208c-.013-2.605-.204-3.602-1.848-3.714-1.518-.104-6.455-.103-7.971 0-1.642.112-1.835 1.104-1.848 3.714.013 2.606.204 3.602 1.848 3.715 1.516.103 6.453.103 7.971 0 1.643-.113 1.835-1.104 1.848-3.715zm-.885-.255v.966h-1.35v.716c0 .285.024.531.308.531.298 0 .315-.2.315-.531v-.264h.727v.285c0 .731-.313 1.174-1.057 1.174-.676 0-1.019-.491-1.019-1.174v-1.704c0-.659.435-1.116 1.071-1.116.678.001 1.005.431 1.005 1.117zm-.726-.007c0-.256-.054-.445-.309-.445-.261 0-.314.184-.314.445v.385h.623v-.385z" })
	  );
	};
	
	exports.default = YoutubeIcon;
	module.exports = exports["default"];

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Menu = __webpack_require__(261);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _BurgerButton = __webpack_require__(255);
	
	var _BurgerButton2 = _interopRequireDefault(_BurgerButton);
	
	var _Socials = __webpack_require__(256);
	
	var _Socials2 = _interopRequireDefault(_Socials);
	
	var _logo = __webpack_require__(646);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _styles = __webpack_require__(498);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainHeader = function (_React$PureComponent) {
	  _inherits(MainHeader, _React$PureComponent);
	
	  function MainHeader() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MainHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
	      opened: false
	    }, _this.toggleOpened = function () {
	      _this.setState(function (state) {
	        return {
	          opened: !state.opened
	        };
	      });
	    }, _this.handleClick = function () {
	      _this.setState({
	        opened: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MainHeader.prototype.render = function render() {
	    return _react2.default.createElement(
	      'header',
	      { className: 'header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header__container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__left' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement('img', {
	              src: _logo2.default,
	              className: 'header__logo',
	              alt: 'Custom Art - ogarniamy koncertowo'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header__right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header__socials' },
	            _react2.default.createElement(_Socials2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header__burger' },
	            _react2.default.createElement(_BurgerButton2.default, { onClick: this.toggleOpened, active: this.state.opened })
	          )
	        )
	      ),
	      _react2.default.createElement(_Menu2.default, { active: this.state.opened, onClick: this.handleClick })
	    );
	  };
	
	  return MainHeader;
	}(_react2.default.PureComponent);
	
	;
	
	exports.default = MainHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menu = [{
	  label: 'O nas',
	  to: '/o-nas'
	}, {
	  label: 'Sztuka i rozrywka',
	  to: '/sztuka-i-rozrywka'
	}, {
	  label: 'Technika estradowa',
	  to: '/technika-estradowa'
	}, {
	  label: 'Organizacja wydarzeń',
	  to: '/organizacja-wydarzen'
	}];
	
	var getActiveLink = function getActiveLink(to) {
	  if (typeof window === "undefined") {
	    return false;
	  }
	  return window.location.pathname === to;
	};
	
	var Menu = function Menu(props) {
	  var menuStyles = (0, _classnames2.default)('menu', {
	    'menu--active': props.active
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: menuStyles },
	    _react2.default.createElement(
	      'div',
	      { className: 'menu__content' },
	      _react2.default.createElement(
	        'nav',
	        { className: 'menu__nav' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'menu__list' },
	          menu.map(function (link) {
	            var classNames = (0, _classnames2.default)('menu__link', {
	              'menu__link--active': getActiveLink(link.to)
	            });
	            return _react2.default.createElement(
	              'li',
	              { className: 'menu__element', key: link.label },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: link.to, className: classNames, onClick: props.onClick },
	                link.label
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '30px' } },
	        _react2.default.createElement(_Button2.default, { type: 'yellow', label: 'Napisz do nas!', mailto: 'mailto:kontakt@customart.pl' })
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PFR = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(503);
	
	var _pfr = __webpack_require__(700);
	
	var _pfr2 = _interopRequireDefault(_pfr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PFR = exports.PFR = function PFR() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'pfr' },
	    _react2.default.createElement('img', { src: _pfr2.default, className: 'pfr__img' })
	  );
	};

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pfr.1d876355.jpeg";

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Helmet = __webpack_require__(26);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _MainHeader = __webpack_require__(257);
	
	var _MainHeader2 = _interopRequireDefault(_MainHeader);
	
	var _HeroLinks = __webpack_require__(93);
	
	var _HeroLinks2 = _interopRequireDefault(_HeroLinks);
	
	var _PFR = __webpack_require__(264);
	
	__webpack_require__(507);
	
	__webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    { className: 'app' },
	    _react2.default.createElement(_Helmet2.default, {
	      title: 'Strona g\u0142\xF3wna',
	      meta: [{ name: 'description', content: 'CustomArt to agencja artystyczna wyspecjalizowana w projektach nietypowych, ambitnych i takich, w których potrzeba niestandardowych rozwiązań na najwyższym poziomie.' }]
	    }),
	    _react2.default.createElement(_MainHeader2.default, null),
	    children(),
	    _react2.default.createElement(_PFR.PFR, null),
	    _react2.default.createElement(_HeroLinks2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0756a645023073c5c823.js